'use client';

import { c as _c } from "react/compiler-runtime";
import { type InheritedRuleTier, inheritedRuleTierLabel } from '@shared/all/domains/spaces';
import Link from 'next/link';
import RuleItem from './RuleItem';
type Props = {
  tiers: InheritedRuleTier[];
  // With no rules of its own, the nearest inherited set is shown in full.
  expandNearest: boolean;
};
const InheritedRules = t0 => {
  const $ = _c(7);
  const {
    tiers,
    expandNearest
  } = t0;
  const expanded = expandNearest ? tiers[tiers.length - 1] : undefined;
  let t1;
  if ($[0] !== expanded || $[1] !== tiers) {
    let t2;
    if ($[3] !== expanded) {
      t2 = tier => <div key={tier.spaceSlug}><Link href={`/s/${tier.spaceSlug}`} className="mx-2 mt-2 block text-sm text-textSecondary hover:underline">{inheritedRuleTierLabel(tier)}</Link>{tier === expanded && <div className="mt-2 space-y-2">{tier.rules.map(_temp2)}</div>}</div>;
      $[3] = expanded;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = tiers.map(t2);
    $[0] = expanded;
    $[1] = tiers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default InheritedRules;
function _temp() {}
function _temp2(rule, index) {
  return <RuleItem key={rule.id} {...rule} index={index} editClickHandler={_temp} isOwner={false} />;
}